// extracted by mini-css-extract-plugin
export var active = "ToggleButton-module--active--vFgxi";
export var button = "ToggleButton-module--button--IpiI0";
export var button__content = "ToggleButton-module--button__content--akbB1";
export var button__content__icon = "ToggleButton-module--button__content__icon--ZVLb+";
export var button__content__text = "ToggleButton-module--button__content__text--rhVUx";
export var fadeInOpacity = "ToggleButton-module--fadeInOpacity--iLxmM";